import React, { useState } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { FavoriteBorder, Favorite } from '@mui/icons-material';
import { useAuth } from '../context/AuthContext';
import { useFavorites } from '../context/FavoritesContext';
import AuthGateDialog from './AuthGateDialog';

function FavoriteButton({ vehicleId, size = 'medium' }) {
  const { isAnonymous } = useAuth();
  const { isFavorite, toggleFavorite } = useFavorites();
  const [showAuthDialog, setShowAuthDialog] = useState(false);
  const favorited = isFavorite(vehicleId);

  const handleClick = async (e) => {
    e.stopPropagation();

    if (isAnonymous && !favorited) {
      setShowAuthDialog(true);
      return;
    }

    await toggleFavorite(vehicleId);
  };

  const handleContinueAsGuest = async () => {
    setShowAuthDialog(false);
    await toggleFavorite(vehicleId);
  };

  return (
    <>
      <Tooltip title={favorited ? 'Remove from favorites' : 'Add to favorites'}>
        <IconButton onClick={handleClick} size={size} color={favorited ? 'error' : 'default'}>
          {favorited ? <Favorite /> : <FavoriteBorder />}
        </IconButton>
      </Tooltip>
      <AuthGateDialog
        open={showAuthDialog}
        onClose={() => setShowAuthDialog(false)}
        onContinueAsGuest={handleContinueAsGuest}
        feature="favorites"
      />
    </>
  );
}

export default FavoriteButton;
